/* eslint-disable no-plusplus */

import { GET_CATEGORIES_FAILURE, GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS } from 'actions/shared.types';

import {
  ADD_CATEGORY_FAILURE,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  ADD_SERVICE_FAILURE,
  ADD_SERVICE_REQUEST,
  ADD_SERVICE_SUCCESS,
  CHANGE_CATEGORY_POSITION,
  CHANGE_SERVICE_POSITION,
  CLEAR_FUTURE_APPOINTMENTS_DATA,
  CLEAR_REQUEST_ERROR,
  CLEAR_SERVICES_STATE,
  DELETE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_SERVICE_FAILURE,
  DELETE_SERVICE_FOR_ROLE_FAILURE,
  DELETE_SERVICE_FOR_ROLE_REQUEST,
  DELETE_SERVICE_FOR_ROLE_SUCCESS,
  DELETE_SERVICE_REQUEST,
  DELETE_SERVICE_SUCCESS,
  EDIT_CATEGORY_FAILURE,
  EDIT_CATEGORY_REQUEST,
  EDIT_CATEGORY_SUCCESS,
  EDIT_SERVICE_FAILURE,
  EDIT_SERVICE_FOR_ROLE_FAILURE,
  EDIT_SERVICE_FOR_ROLE_REQUEST,
  EDIT_SERVICE_FOR_ROLE_SUCCESS,
  EDIT_SERVICE_REQUEST,
  EDIT_SERVICE_SUCCESS,
  GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE,
  GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST,
  GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS,
  GET_SERVICE_FAILURE,
  GET_SERVICE_REQUEST,
  GET_SERVICE_SUCCESS,
  GET_SERVICE_TAXES_AND_FEES_FAILURE,
  GET_SERVICE_TAXES_AND_FEES_REQUEST,
  GET_SERVICE_TAXES_AND_FEES_SUCCESS,
  GET_SERVICE_TEMPLATES_FAILURE,
  GET_SERVICE_TEMPLATES_REQUEST,
  GET_SERVICE_TEMPLATES_SUCCESS,
  GET_SERVICES_FAILURE,
  GET_SERVICES_REQUEST,
  GET_SERVICES_SUCCESS,
  MARK_CATEGORIES_AS_FETCHED,
  POST_SERVICE_FOR_ROLE_FAILURE,
  POST_SERVICE_FOR_ROLE_REQUEST,
  POST_SERVICE_FOR_ROLE_SUCCESS,
  POST_SERVICE_TAXES_AND_FEES_FAILURE,
  POST_SERVICE_TAXES_AND_FEES_REQUEST,
  POST_SERVICE_TAXES_AND_FEES_SUCCESS,
  REMOVE_SAVED_CATEGORIES_IDS,
  REMOVE_SAVED_SERVICES_IDS,
  SET_SERVICE_SAVED,
} from 'onboarding/services/actions';
import { sumUpFutureAppointments } from 'onboarding/services/utils';

const initState = {
  categories: [],
  errorMessage: '',
  isFetching: false,
  isPosting: false,
  isSaved: false,
  areCategoriesFetched: false,
  serviceTemplates: [],
  isServiceSaved: false,
  settingsSavedCategoriesIDs: [],
  settingsErrorCategoriesIDs: [],
  settingsSavedServicesIDs: [],
  settingsErrorServicesIDs: [],
  changePrice: {
    futureAppointments: {
      isFetching: false,
      response: null,
    },
  },
  servicePriceHasChanged: false,
};

const servicesReducer = (state = initState, action) => {
  if (action && action.type) {
    switch (action.type) {
      case GET_CATEGORIES_REQUEST: {
        return { ...state, areCategoriesFetched: false, isFetching: true };
      }
      case GET_CATEGORIES_SUCCESS: {
        const categories = action.response;
        let isSignUp = false;
        if (document.location.href.indexOf('salon/#/signup') > 0) {
          isSignUp = true;
        }
        const rorderedCategories = [];
        if (isSignUp) {
          const orderArr = ['Colour', 'Cutting', 'Styling', 'Treatments'];
          for (let i = 0; i < orderArr.length; i += 1) {
            const cat = categories.filter((category) => category.name === orderArr[i]);
            if (cat.length > 0) {
              rorderedCategories.push(cat[0]);
            }
          }
          const allKeys = categories.map((c, index) => [c.name, index]);
          for (let i = 0; i < allKeys.length; i += 1) {
            if (orderArr.indexOf(allKeys[i][0]) < 0) {
              rorderedCategories.push(categories[allKeys[i][1]]);
            }
          }
        }
        return {
          ...state,
          categories: isSignUp ? rorderedCategories : categories,
          isFetching: false,
          areCategoriesFetched: true,
        };
      }
      case MARK_CATEGORIES_AS_FETCHED: {
        return {
          ...state,
          areCategoriesFetched: true,
        };
      }
      case GET_CATEGORIES_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      case ADD_CATEGORY_REQUEST: {
        return { ...state, isSaved: false, isPosting: true };
      }
      case ADD_CATEGORY_SUCCESS: {
        const categories = state.categories.slice();

        categories.push({ ...action.response, services: [] });

        return {
          ...state,
          categories,
          isPosting: false,
          isSaved: true,
        };
      }
      case ADD_CATEGORY_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case EDIT_CATEGORY_REQUEST: {
        return { ...state, isPosting: true, isSaved: false };
      }
      case EDIT_CATEGORY_SUCCESS: {
        const categories = state.categories.slice();

        const settingsSavedCategoriesIDs = state.settingsSavedCategoriesIDs.slice();
        const responseId = action.response.id;

        const settingsErrorCategoriesIDs = state.settingsErrorCategoriesIDs.slice().filter((cat) => cat.id !== responseId);

        const savedCatInd = settingsSavedCategoriesIDs.findIndex((cat) => cat.id === responseId);
        if (action.response.id && savedCatInd === -1) {
          settingsSavedCategoriesIDs.push({ id: action.response.id, isNew: true });
        } else {
          settingsSavedCategoriesIDs[savedCatInd].isNew = true;
        }

        for (let i = 0; i < categories.length; i += 1) {
          if (categories[i].id === action.response.id) {
            categories[i].name = action.response.name;
            categories[i].color = action.response.color;
            break;
          }
        }
        return {
          ...state,
          settingsErrorCategoriesIDs,
          settingsSavedCategoriesIDs,
          errorMessage: '',
          categories,
          isPosting: false,
          isSaved: true,
        };
      }
      case EDIT_CATEGORY_FAILURE: {
        const settingsErrorCategoriesIDs = state.settingsErrorCategoriesIDs.slice();
        const responseId = action.params.categoryId;
        const savedCatInd = settingsErrorCategoriesIDs.findIndex((cat) => cat.id === responseId);

        if (savedCatInd === -1) {
          settingsErrorCategoriesIDs.push({ id: responseId, message: action.errorMessage });
        } else {
          settingsErrorCategoriesIDs[savedCatInd].message = action.errorMessage;
        }

        return {
          ...state,
          isPosting: false,
          errorMessage: action.errorMessage,
          settingsErrorCategoriesIDs,
        };
      }
      case DELETE_CATEGORY_REQUEST: {
        return { ...state, isPosting: true };
      }
      case DELETE_CATEGORY_SUCCESS: {
        const categories = state.categories.slice();
        for (let i = 0; i < categories.length; i += 1) {
          if (categories[i].id === action.params.categoryId) {
            categories.splice(i, 1);
            break;
          }
        }
        return { ...state, categories, isPosting: false };
      }
      case DELETE_CATEGORY_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case GET_SERVICES_REQUEST: {
        return { ...state, isFetching: true };
      }
      case GET_SERVICES_SUCCESS: {
        if (!state.categories) {
          return { ...state };
        }
        const categories = state.categories.slice();
        for (let i = 0; i < categories.length; i += 1) {
          if (categories[i].id === action.params.categoryId) {
            const category = Object.assign({}, categories[i]);
            category.services = action.response;
            categories[i] = category;
          }
        }
        return {
          ...state,
          categories,
          isFetching: false,
        };
      }
      case GET_SERVICES_FAILURE: {
        return {
          ...state,
          isFetching: false,
          errorMessage: action.errorMessage,
        };
      }
      case GET_SERVICE_TAXES_AND_FEES_REQUEST: {
        return { ...state, isFetching: true };
      }
      case GET_SERVICE_TAXES_AND_FEES_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      case GET_SERVICE_TAXES_AND_FEES_SUCCESS: {
        const categories = state.categories.slice();
        for (let i = 0; i < categories.length; i += 1) {
          const category = Object.assign({}, categories[i]);
          for (let j = 0; j < category.services.length; j += 1) {
            if (category.services[j].id === action.params.serviceId) {
              category.services[j].tax_ids = action.response.results.taxes;
              category.services[j].fee_ids = action.response.results.fees;
              category.services[j].is_tax_exempt = action.response.results.is_tax_exempt;
              category.services[j].tax_exempt_reason = action.response.results.tax_exempt_reason;
            }
          }
          categories[i] = category;
        }
        return { ...state, categories, isFetching: false };
      }
      case GET_SERVICE_REQUEST: {
        return { ...state, isFetching: true };
      }
      case GET_SERVICE_SUCCESS: {
        const categories = state.categories.slice();
        for (let i = 0; i < categories.length; i += 1) {
          const category = Object.assign({}, categories[i]);
          if (!category.services) {
            category.services = [];
          }
          let added = false;
          for (let j = 0; j < category.services.length; j += 1) {
            if (category.services[j].id === action.response.id) {
              if (category.id !== action.response.category) {
                category.services.splice(j, 1);
              } else {
                category.services[j] = action.response;
                added = true;
              }
            }
          }
          if (!added && category.id === action.response.category) {
            category.services.push(action.response);
          }
          categories[i] = category;
        }
        return { ...state, categories, isFetching: false };
      }
      case GET_SERVICE_FAILURE: {
        return { ...state, isFetching: false, errorMessage: action.errorMessage };
      }
      case ADD_SERVICE_REQUEST: {
        return { ...state, isPosting: true, isSaved: false };
      }
      case ADD_SERVICE_SUCCESS: {
        const categories = state.categories.slice();
        for (let i = 0; i < categories.length; i += 1) {
          if (categories[i].id === action.params.categoryId) {
            const category = Object.assign({}, categories[i]);
            if (!category.services) {
              category.services = [];
            }
            category.services.push(action.response);
            categories[i] = category;
          }
        }
        return {
          ...state,
          categories,
          isPosting: false,
          isSaved: true,
        };
      }
      case ADD_SERVICE_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case EDIT_SERVICE_REQUEST: {
        return { ...state, isPosting: true, isSaved: false };
      }
      case EDIT_SERVICE_SUCCESS: {
        const categories = state.categories.slice();

        const settingsSavedServicesIDs = state.settingsSavedServicesIDs.slice();
        const serviceId = action.response.id;
        const settingsErrorServicesIDs = state.settingsErrorServicesIDs.slice();
        let newSettingsErrorServicesIDs = [];
        if (settingsErrorServicesIDs.length) {
          newSettingsErrorServicesIDs = settingsErrorServicesIDs.filter((srvs) => srvs && srvs.ErrorIds !== serviceId);
        }
        let savedSrvsInd = -1;
        if (settingsSavedServicesIDs.length) {
          savedSrvsInd = settingsSavedServicesIDs.findIndex((srvs) => srvs && srvs.id === serviceId);
        }
        if (serviceId && savedSrvsInd === -1) {
          settingsSavedServicesIDs.push({ id: serviceId, isNew: true });
        } else {
          settingsSavedServicesIDs[savedSrvsInd].isNew = true;
        }

        for (let i = 0; i < categories.length; i += 1) {
          if (categories[i].id === action.response.category) {
            const category = Object.assign({}, categories[i]);
            for (let j = 0; j < categories[i].services.length; j += 1) {
              if (categories[i].services[j] && categories[i].services[j].id && categories[i].services[j].id === action.response.id) {
                let service = Object.assign({}, categories[i].services[j]);
                service = action.response;
                categories[i].services[j] = service;
                break;
              }
            }
            categories[i] = category;
          }
        }
        return {
          ...state,
          categories,
          settingsSavedServicesIDs,
          settingsErrorServicesIDs: newSettingsErrorServicesIDs,
          isPosting: false,
          isSaved: true,
        };
      }
      case EDIT_SERVICE_FAILURE: {
        const settingsErrorServicesIDs = state.settingsErrorServicesIDs.slice();
        const srvsId = action.params.serviceId;
        let savedSrvsInd = -1;
        if (settingsErrorServicesIDs.length > 0) {
          savedSrvsInd = settingsErrorServicesIDs.findIndex((srvs) => srvs.id === srvsId);
        }

        if (savedSrvsInd === -1) {
          settingsErrorServicesIDs.push({ id: srvsId, message: action.errorMessage });
        } else {
          settingsErrorServicesIDs[savedSrvsInd].message = action.errorMessage;
        }
        return {
          ...state,
          isPosting: false,
          errorMessage: action.errorMessage,
          settingsErrorServicesIDs,
        };
      }
      case DELETE_SERVICE_REQUEST: {
        return { ...state, isPosting: true };
      }
      case DELETE_SERVICE_SUCCESS: {
        const categories = state.categories.slice();
        for (let i = 0; i < categories.length; i += 1) {
          for (let j = 0; j < categories[i].services.length; j += 1) {
            if (categories[i].services[j].id === action.params.serviceId) {
              const category = Object.assign({}, categories[i]);
              category.services.splice(j, 1);
              break;
            }
          }
        }
        return { ...state, categories, isPosting: false };
      }
      case POST_SERVICE_TAXES_AND_FEES_REQUEST: {
        return { ...state, isPosting: true };
      }
      case POST_SERVICE_TAXES_AND_FEES_SUCCESS: {
        return { ...state, isPosting: false };
      }
      case POST_SERVICE_TAXES_AND_FEES_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case DELETE_SERVICE_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case POST_SERVICE_FOR_ROLE_REQUEST: {
        return { ...state, isPosting: true };
      }
      case POST_SERVICE_FOR_ROLE_SUCCESS: {
        return { ...state, isPosting: false };
      }
      case POST_SERVICE_FOR_ROLE_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case EDIT_SERVICE_FOR_ROLE_REQUEST: {
        return { ...state, isPosting: true };
      }
      case EDIT_SERVICE_FOR_ROLE_SUCCESS: {
        return { ...state, isPosting: false };
      }
      case EDIT_SERVICE_FOR_ROLE_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case DELETE_SERVICE_FOR_ROLE_REQUEST: {
        return { ...state, isPosting: true };
      }
      case DELETE_SERVICE_FOR_ROLE_SUCCESS: {
        return { ...state, isPosting: false };
      }
      case DELETE_SERVICE_FOR_ROLE_FAILURE: {
        return { ...state, isPosting: false, errorMessage: action.errorMessage };
      }
      case GET_SERVICE_TEMPLATES_REQUEST: {
        return { ...state, isFetching: true };
      }
      case GET_SERVICE_TEMPLATES_SUCCESS: {
        return { ...state, serviceTemplates: action.response, isFetching: false };
      }
      case GET_SERVICE_TEMPLATES_FAILURE: {
        return {
          ...state,
          isFetching: false,
          errorMessage: action.errorMessage,
        };
      }
      case CLEAR_SERVICES_STATE: {
        return {
          ...state,
          isFetching: false,
          isPosting: false,
          isSaving: false,
          isServiceSaved: false,
          errorMessage: '',
        };
      }
      case SET_SERVICE_SAVED: {
        return { ...state, isServiceSaved: action.value };
      }
      case CLEAR_REQUEST_ERROR: {
        return { ...state, errorMessage: '' };
      }
      case REMOVE_SAVED_CATEGORIES_IDS: {
        const { idsToRemove } = action;
        const settingsSavedCategoriesIDs = state.settingsSavedCategoriesIDs.filter((category) => idsToRemove.indexOf(category.id) < 0);

        return {
          ...state,
          settingsSavedCategoriesIDs,
        };
      }
      case REMOVE_SAVED_SERVICES_IDS: {
        const { idsToRemove } = action;
        const settingsSavedServicesIDs = state.settingsSavedServicesIDs.filter((srvs) => idsToRemove.indexOf(srvs.id) < 0);

        return {
          ...state,
          settingsSavedServicesIDs,
        };
      }
      case CHANGE_SERVICE_POSITION: {
        const { serviceToInsert, serviceAt } = action;
        const categories = state.categories.slice();
        const categoryToEditIndex = categories.findIndex((category) => category.id === serviceToInsert.category);
        let whereToRemoveInd = -1;
        let whereToAddIndex = -1;

        for (let i = 0; i < categories[categoryToEditIndex].services.length; i++) {
          const currentService = categories[categoryToEditIndex].services[i];
          if (currentService.id === serviceToInsert.id) {
            whereToRemoveInd = i;
          }
          if (currentService.id === serviceAt.id) {
            whereToAddIndex = i;
          }
        }
        if (whereToRemoveInd !== whereToAddIndex && whereToRemoveInd !== -1 && whereToAddIndex !== -1) {
          categories[categoryToEditIndex].services.splice(whereToRemoveInd, 1);
          categories[categoryToEditIndex].services.splice(whereToAddIndex, 0, serviceToInsert);
        }

        return {
          ...state,
          categories,
        };
      }
      case CHANGE_CATEGORY_POSITION: {
        const { categoryToInsert, categoryAt } = action;
        const categories = state.categories.slice();
        let whereToRemoveInd = -1;
        let whereToAddIndex = -1;

        for (let i = 0; i < categories.length; i++) {
          const currentCategory = categories[i];
          if (currentCategory.id === categoryToInsert.id) {
            whereToRemoveInd = i;
          }
          if (currentCategory.id === categoryAt.id) {
            whereToAddIndex = i;
          }
        }
        if (whereToRemoveInd !== whereToAddIndex && whereToRemoveInd !== -1 && whereToAddIndex !== -1) {
          categories.splice(whereToRemoveInd, 1);
          categories.splice(whereToAddIndex, 0, categoryToInsert);
        }

        return {
          ...state,
          categories,
        };
      }
      case GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST: {
        return {
          ...state,
          changePrice: {
            ...state.changePrice,
            futureAppointments: {
              isFetching: true,
              response: null,
            },
          },
        };
      }
      case GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS: {
        return {
          ...state,
          changePrice: {
            ...state.changePrice,
            futureAppointments: {
              isFetching: false,
              response: sumUpFutureAppointments(action.response),
            },
          },
        };
      }
      case GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE: {
        return {
          ...state,
          changePrice: {
            ...state.changePrice,
            futureAppointments: {
              isFetching: false,
              response: null,
              errorMessage: action.errorMessage,
            },
          },
        };
      }
      case CLEAR_FUTURE_APPOINTMENTS_DATA: {
        return {
          ...state,
          changePrice: {
            ...state.changePrice,
            futureAppointments: {
              isFetching: false,
              response: null,
            },
          },
        };
      }
      default:
        return state;
    }
  }

  return state;
};

export default servicesReducer;
